import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class TextImageRedirectionSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            imagesLoaded: true,
            cellSelector: '.text-image-redirection__single',
            cellAlign: 'center',
            groupCells: '50%',
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.text-image-redirection__single');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 1 && document.body.clientWidth < 845) {
            this._destroy();
            this._createSlider();
            console.log('slider mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 845 && document.body.clientWidth < 1200) {
            this._destroy();
            this._createSlider();
            console.log("slider tablet");
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 1200) {
            this._destroy();
            this._createSlider();
            console.log("no slider laptop");
        } else if(this.slidesCount <= 4 && document.body.clientWidth >= 1700) {
            this._destroy();
            console.log("no slider");
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if(document.body.clientWidth < 845 && this.slidesCount > 1){
            this._destroy();
            this._createSlider();
            console.log('slider resize mobile');
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 845 && document.body.clientWidth < 1200) {
            this._destroy();
            this._createSlider();
            console.log('slider resize laptop');
        } else if(this.slidesCount > 3 && document.body.clientWidth >= 1200) {
            this._destroy();
            this._createSlider();
            console.log('slider destroy laptop');
        } else if(this.slidesCount <= 4 && document.body.clientWidth >= 1700) {
            this._destroy();
            console.log('slider destroy');
        }
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
    
}

export default TextImageRedirectionSlider;
